/** What the start button says when the room has the wrong number of people for its game. */
export function startBlocker(
  connected: number,
  players: { min: number; max: number },
  gameName: string,
): string | null {
  if (connected < players.min)
    return players.min - connected === 1
      ? "Waiting for a friend to join"
      : `Waiting for ${String(players.min - connected)} more friends`;
  if (connected > players.max)
    return `${gameName} is for ${players.min === players.max ? String(players.max) : `up to ${String(players.max)}`} players: ${String(connected)} are here`;
  return null;
}

/** Two against two needs two a side (ADR 0028): why the start waits, or null. */
export function teamsBlocker(teams: Record<string, number> | undefined): string | null {
  if (!teams) return null;
  const sides = Object.values(teams);
  return sides.filter((t) => t === 0).length === 2 && sides.filter((t) => t === 1).length === 2
    ? null
    : "Two a side to start";
}
